import {useTranslation} from "react-i18next";

export const useLoginErrorMessage = error => {
  const {t} = useTranslation();

  const getErrorMessage = () => {
    if (error?.message?.includes("suspendida")) {
      return error.message;
    }
    return t("loginIncorrectPasswordEmail");
  };

  return {getErrorMessage};
};
